import { Tooltip } from "devextreme-react";
import { Position } from "devextreme-react/tooltip";
import { formatDate } from "devextreme/localization";

type Props = { timestamp: string; ticker: string | undefined; assetGroupId?: string };

export default function StockPriceTooltip({ timestamp, ticker, assetGroupId }: Props) {
  return (
    <div id={`${ticker}-stock-info-tooltip-${assetGroupId ?? ""}`} className="relative">
      <i className="dx-icon-info absolute -left-6 bottom-0 px-2 text-2xl !text-primary" />
      <Tooltip
        showEvent="mouseenter"
        hideEvent="mouseleave"
        hideOnOutsideClick={false}
        target={`#${ticker}-stock-info-tooltip-${assetGroupId ?? ""}`}
      >
        <Position at={"top"} my={"top"} />
        Found {ticker} price for earlier date <br />
        {formatDate(new Date(timestamp!), "MM/dd/yyyy")}
      </Tooltip>
    </div>
  );
}
